export const parseDateOnly = value => {
  if (!value) return null;
  const match = String(value).slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return new Date(value);
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
};

export const formatDateOnly = (value, options = {}) => {
  const date = parseDateOnly(value);
  if (!date || Number.isNaN(date.getTime())) return 'Not specified';
  return date.toLocaleDateString('en-CA', options);
};
